import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const selectedIdsSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.dismiss.selectedIds;
  },
);
